import accessControlEvents from './access-control-events.json';

export default {
  accessControlEvents,
};
